// extracted by mini-css-extract-plugin
export default {"Modal":"QuestionModal_Modal__ixVXJ"};